/* eslint-disable import/no-unresolved */
import CustomTextField from "src/shared/CustomTextField";
import CustomSelect from "src/shared/CustomSelect";
import CustomCheckBox from "src/shared/CustomCheckBox";
import { useAppSelector } from "src/utils/hooks/useAppSelector";

interface Props {
  formik: any;
  genericDetails: any;
}

function BankDetails({ formik, genericDetails }: Props) {
  const handleCheckboxChange = (name: string) => {
    const otherCheckboxes = ["isCoBorrower", "isGuarantor", "isPrimaryBorrower"].filter(
      (checkbox) => checkbox !== name
    );
    otherCheckboxes.forEach((checkbox) => formik.setFieldValue(checkbox, false));
  };
  const jointLifeAddendum = useAppSelector((state) => state.jointLifeAddendum);
  const isProportionateLead = useAppSelector((state) => state.common?.isProportionateLead);

  return (
    <div>
      <div className="flex flex-col md:flex-row justify-between mb-6">
        {genericDetails?.bankCustomerId?.visible && (
          <div className="w-full md:w-222/1000 mb-6 md:mb-0">
            <CustomTextField
              requiredStar={genericDetails?.bankCustomerId?.required}
              label={genericDetails?.bankCustomerId?.label}
              disabledField={genericDetails?.bankCustomerId?.disabled}
              onChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              value={formik.values.bankCustomerId}
              name="bankCustomerId"
              error={formik.errors.bankCustomerId}
              touched={formik.touched.bankCustomerId}
            />
          </div>
        )}
        {genericDetails?.branchSalesManagerCode?.visible && (
          <div className="w-full md:w-222/1000 mb-6 md:mb-0">
            <CustomTextField
              requiredStar={genericDetails?.branchSalesManagerCode?.required}
              disabledField={
                isProportionateLead && genericDetails?.branchSalesManagerCode?.disabled
              }
              label={genericDetails?.branchSalesManagerCode?.label}
              onChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              value={formik.values.branchSalesManagerCode}
              name="branchSalesManagerCode"
              error={formik.errors.branchSalesManagerCode}
              touched={formik.touched.branchSalesManagerCode}
            />
          </div>
        )}
        {genericDetails?.typeOfLoan?.visible && (
          <div className="w-full md:w-222/1000 mb-6 md:mb-0">
            <CustomSelect
              requiredStar={genericDetails?.typeOfLoan?.required}
              disabledField={isProportionateLead && genericDetails?.typeOfLoan?.disabled}
              label={genericDetails?.typeOfLoan?.label}
              options={["NEW", "EXISTING"]}
              onChange={formik.handleChange}
              setFieldTouched={formik.setFieldTouched}
              name="typeOfLoan"
              value={formik.values.typeOfLoan}
              error={formik.errors.typeOfLoan}
              touched={formik.touched.typeOfLoan}
            />
          </div>
        )}
        {genericDetails?.st2Code?.visible && (
          <div className="w-full md:w-222/1000">
            <CustomTextField
              requiredStar={genericDetails?.st1Code?.required}
              label={genericDetails?.st1Code?.label}
              disabledField={genericDetails?.st1Code?.disabled}
              onChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              value={formik.values?.st1Code}
              name="st1Code"
              error={formik.errors?.st1Code}
              touched={formik.touched?.st1Code}
            />
          </div>
        )}
      </div>
      <div className="grid md:grid-cols-6 md:col-2 gap-2 sm:my-8">
        {genericDetails?.coBorrowerFlag?.visible && (
          <div className="w-full">
            <CustomCheckBox
              label={genericDetails?.coBorrowerFlag?.label}
              name="isCoBorrower"
              handleBlur={formik.handleBlur}
              setFieldValue={formik.setFieldValue}
              checked={formik.values?.isCoBorrower}
              onChange={() => handleCheckboxChange("isCoBorrower")}
            />
          </div>
        )}
        {genericDetails?.guarantorFlag?.visible && (
          <div className="w-full">
            <CustomCheckBox
              isReview={jointLifeAddendum?.jointGuarantorFlag}
              label={genericDetails?.guarantorFlag?.label}
              name="isGuarantor"
              handleBlur={formik.handleBlur}
              setFieldValue={formik.setFieldValue}
              checked={formik.values?.isGuarantor}
              onChange={() => handleCheckboxChange("isGuarantor")}
            />
          </div>
        )}
        <div className="w-full">
          <CustomCheckBox
            label="Primary Borrower"
            name="isPrimaryBorrower"
            handleBlur={formik.handleBlur}
            setFieldValue={formik.setFieldValue}
            checked={formik.values?.isPrimaryBorrower}
            onChange={() => handleCheckboxChange("isPrimaryBorrower")}
          />
        </div>
      </div>
    </div>
  );
}

export default BankDetails;
